import { select, observe, parseDuration } from './_util.js';

/**
 * Add a ken burns animation effect to an image when visible
 *
 * @param {String|Array|NodeList|HTMLElement} selector this is the figure or wrapping node that contains an image
 * @param {object} opts
 * @returns {Array}
 */
export function kenBurns( selector, opts = {} ) {
	return select( selector ).forEach( ( node ) => {
		node.classList.add( 'animated-ken-burns' );

		if ( opts.duration ) {
			node.style.animationDuration = parseDuration( opts.duration );
		}

		observe( node, { threshold: opts.threshold } ).then( () => setTimeout( () => node.classList.add( 'animated-ken-burns--active' ), opts.delay ) );
	} );
}
